import { Flex } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { Paragraph } from 'ui-components';
import { SearchLocation } from '~/screens/MyAgency/components/SearchLocation';
import { useCreatorsFiltersStore } from '~/screens/MyAgency/store';
import { ICreatorLocation } from '~/types';

import { talentFiltersTrackId } from './constants';

export const SearchByLocation: React.FC = () => {
  const { location, setLocation } = useCreatorsFiltersStore();
  const [values, setValues] = useState<ICreatorLocation>(location);

  useEffect(() => {
    setValues(location);
  }, [location, setValues]);

  const selectLocation = useCallback(
    (value: ICreatorLocation) => {
      setValues(value);
      setLocation(value);
    },
    [setValues, setLocation],
  );

  return (
    <Flex
      flexDirection="column"
      gap={2}
      track-id={talentFiltersTrackId.location}
    >
      <Paragraph
        size="lg"
        fontWeight="medium"
        color="primary.500"
        sx={{
          lineHeight: 6,
        }}
      >
        Location
      </Paragraph>
      <SearchLocation
        title="Location"
        values={values}
        setValues={selectLocation}
      />
    </Flex>
  );
};
